<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        small
        color="primary"
        @click="dialog = true"
        ><v-icon left>mdi-upload</v-icon>{{ title }}</v-btn
      >
    </template>

    <v-card class="primary--text" v-if="dialog">
      <validation-observer ref="form" v-slot="{ invalid }">
        <v-card-title> {{ title }} </v-card-title>
        <v-card-text @drop.prevent="addDropFile" @dragover.prevent class="pt-0">
          <validation-provider
            ref="fileInputRef"
            :rules="{ required: true }"
            v-slot="{ errors }"
          >
            <v-file-input
              v-model="selectedFiles"
              prepend-icon="mdi-paperclip"
              label="Select File(s)"
              counter
              multiple
              chips
              truncate-length="6"
              single-line
              :error-messages="errors"
            ></v-file-input>
          </validation-provider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :dark="!loading"
            :disabled="loading"
            text
            @click="clear"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :dark="!loading && !invalid"
            :disabled="loading || invalid"
            text
            @click.once="upload"
            >Save</v-btn
          >
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["title"],
  data() {
    return {
      dialog: false,
      selectedFiles: [],
      loading: false,
    };
  },
  methods: {
    addDropFile(e) {
      this.selectedFiles.push(...Array.from(e.dataTransfer.files));
      this.$refs.fileInputRef.validate();
    },
    async upload() {
      this.loading = true;
      this.$emit("uploadFiles", this.selectedFiles, async () => {
        this.clear();
      });
    },
    clear() {
      this.$refs.form.reset();
      this.selectedFiles = [];
      this.dialog = false;
    },
  },
};
</script>
